// @ts-check
import {
  CONFIGURATION_SELECT,
  CONFIGURATION_DESELECT,
  CONFIGURATION_CREATE_START,
  CONFIGURATION_CREATE_STOP,
  UNLOAD,
} from './types';

/**
 * @typedef {Object} Payload
 * @property {number} id
 *
 * @param {number} id
 * @returns { import('flux-standard-action').FSAWithPayload<CONFIGURATION_SELECT, Payload> }
 */
export function selectConfiguration(id) {
  return {
    type: CONFIGURATION_SELECT,
    payload: {
      id,
    },
  };
}

/**
 *
 * @returns { import('flux-standard-action').FSA<CONFIGURATION_DESELECT> }
 */
export function deselectConfiguration() {
  return {
    type: CONFIGURATION_DESELECT,
  };
}

/**
 *
 * @returns { import('flux-standard-action').FSA<CONFIGURATION_CREATE_START> }
 */
export function startCreation() {
  return {
    type: CONFIGURATION_CREATE_START,
  };
}

/**
 *
 * @returns { import('flux-standard-action').FSA<CONFIGURATION_CREATE_STOP> }
 */
export function stopCreation() {
  return {
    type: CONFIGURATION_CREATE_STOP,
  };
}

/**
 *
 * @returns { import('flux-standard-action').FSA<UNLOAD> }
 */
export function unload() {
  return {
    type: UNLOAD,
  };
}
